{{#if preview}}
  <em>This field will allow the user to register for event sessions.</em>
{{else}}
  <div class="sessions-input" data-behaviour="sessions-input">
    {{> elements/_input type="hidden" name="sessions" behaviour="slot-input" }}
    {{#each sessions}}
      <section data-component-template="expandable_section" class="expandable-section component omega" data-page-relation="unique">
        <div class="component-content">
          <header data-context-name="title" class="expandable-title {{#unless ../collapsed}}expandable-open expandable-disabled{{/unless}}">
            <h4 class="expandable-section-title">{{name}}</h4>
            <span class="no-slots">Session is unavailable</span>
            <div class="icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" enable-background="new 0 0 320 320"><path d="M226.7 134.4c-2.3-2.4-6.1-2.4-8.5 0l-59 58.6-57.5-57.2c-2.4-2.3-6.1-2.3-8.5 0-2.3 2.4-2.3 6.1 0 8.5l61.8 61.4c1.2 1.2 2.7 1.7 4.2 1.7s3.1-.6 4.2-1.7l63.2-62.8c2.5-2.4 2.5-6.2.1-8.5z"/></svg>
            </div>
          </header>
          <div class="expandable-body">
            <div class="session-slot-selector">
              <div class="time-list">
                {{#each times}}
                  <button type="button" data-behaviour="time-selection" data-start-time="{{start_time}}" data-time="{{time}}" class="time-button">{{time}}</button>
                {{/each}}
              </div>

              {{#each times}}
                <div class="provider-list" data-time="{{time}}">
                  <p>Provider</p>

                  {{#each tracks}}
                    <button type="button" data-behaviour="slot-selection" class="slot-button" data-slot-preview='{"name": "{{ ../../name }}", "time": "{{ ../time }}", "track": "{{ name }}" }' data-slot-id="{{id}}" data-start-time="{{start_time}}" data-end-time="{{end_time}}">{{name}}</button>
                  {{/each}}
                </div>
              {{/each}}
            </div>
          </div>
        </div>
      </section>
    {{/each}}
  </div>
  <script>
    if (window.SessionsFormFieldManager) { SessionsFormFieldManager.decorateAll(); }
  </script>
{{/if}}
